export default __webpack_public_path__ + "static/murano-apartamentos-8cfefab98cc58850cbd06148ebfdf7ae.jpg";